module.exports = __webpack_public_path__ + "img/investment_6.b7e35ba9.jpg";